import { ApolloError, useQuery } from "@apollo/client";
import { GET_POLICY_ACTIONS_BY_TYPE, GET_ALARM_POLICIES } from "graphql/queries";
import { PolicyType, PolicyAction, AlarmPolicy } from "types";

export function usePolicyActionsByType(type?: PolicyType): [PolicyAction[], boolean, ApolloError | undefined] {
    const policyType = type === "remediationpolicyrel" ? "remediationaction" : "alarmaction";
    const { data, loading, error } = useQuery<{ policyActionsByType: PolicyAction[] }>(GET_POLICY_ACTIONS_BY_TYPE, {
        variables: { type: policyType },
        errorPolicy: "all"
    });

    return [data ? data.policyActionsByType : [], loading, error];
}

const policyActionReducer = (a: PolicyAction) => {
    return { ...a, type: a.evaluationPolicy ? "remediationaction" : "alarmaction" };
};

export function useAlarmPolicies(
    companyId: string | undefined,
    alarmType?: string
): [AlarmPolicy[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<{ alarmPolicies: AlarmPolicy[] }>(GET_ALARM_POLICIES, {
        variables: { companyId, alarmType },
        errorPolicy: "all",
        skip: !companyId
    });
    const res = data
        ? data.alarmPolicies.map((r) => {
              const pols = r.policies.map((p) => policyActionReducer(p));
              return {
                  ...r,
                  type:
                      r.type === "actionpolicyrel"
                          ? "action policy"
                          : r.type === "remediationpolicyrel"
                          ? "remediation policy"
                          : "unknown",
                  policies: pols
              } as AlarmPolicy;
          })
        : [];
    return [res, loading, error];
}
